// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledInput from '../../../claim/shared/components/claim-fields/labeled-input';
import Option from '@deere/cps-it.warranty-model-factory/lib/option';
import {isNotEmpty} from '../../../claim/shared/services/claim-shared-helper';

function handleInputChange(property, value) {

    this.onInputChange(property, value);

}

function handleButtonClick() {

    this.onCreateOption();

}

const AddOptionForm = props =>
    <div className='add-option-form'>
        <LabeledInput
            className='option-code'
            isEditable={true}
            label='OPTION_CODE'
            onChange={handleInputChange.bind(props, 'optionCode')}
            value={props.option.optionCode}
        />
        <LabeledInput
            className='description'
            isEditable={true}
            label='DESCRIPTION'
            onChange={handleInputChange.bind(props, 'description')}
            value={props.option.description}
        />
        <button
            className='create-button'
            disabled={!(isNotEmpty(props.option.optionCode) && isNotEmpty(props.option.description))}
            onClick={props::handleButtonClick}
        >
            <FormattedMessage id='ADD_OPTION'/>
        </button>
    </div>;

AddOptionForm.displayName = 'AddOptionForm';
AddOptionForm.propTypes = {
    onCreateOption: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    option: PropTypes.instanceOf(Option).isRequired
};

export default AddOptionForm;



// WEBPACK FOOTER //
// ./src/product/details/components/add-option-form.js